import React, { Fragment } from "react";
import type { FC, PropsWithChildren } from "react";
import { Modal, ModalButtons, ModalForm } from "../../components/Modal";
import ModalHeading from "../../components/Modal/ModalHeading";

import { InputBox, InputsSection } from "../../components/Modal";
import FileUpload from "../../components/Modal/FileUpload";
import ResourceFormSkeleton from "../../Skeletons/ResourceFormSkeleton";

export type AddEditModalState = PropsWithChildren<{
  status: boolean;
}>;
export type IaddEditModalStates = PropsWithChildren<{
  resourceName: { value: string; error: string };
  singleFile: { value: File | null; error: string };
}>;

type AddEditModalProps = PropsWithChildren<{
  loading: boolean;
  addEditModal: AddEditModalState;
  onCloseModal?: () => void;
  handleAddEdit?: (event: React.FormEvent<HTMLFormElement>) => void;
  addEditModalStates: IaddEditModalStates;
  setAddEditModalStates: React.Dispatch<
    React.SetStateAction<IaddEditModalStates>
  >;
  handleFileChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}>;

const AddEditModal: FC<AddEditModalProps> = (props) => {
  return (
    <Modal show={props.addEditModal.status} style={{ width: "50%" }}>
      <ModalHeading heading="Add RTM Resource" />

      {props.loading ? (
        <ResourceFormSkeleton />
      ) : (
        <ModalForm
          style={{ marginBottom: "2.5rem" }}
          onSubmit={props.handleAddEdit}
        >
          <InputsSection style={{ display: "flex", flexDirection: "column" }}>
            <InputBox
              label="Name"
              placeholder="eg, John Smith"
              value={props.addEditModalStates.resourceName.value}
              onChange={(event) => {
                props.setAddEditModalStates((prevVal) => ({
                  ...prevVal,
                  resourceName: { value: event.target.value, error: "" },
                }));
              }}
              errorMessage={props.addEditModalStates.resourceName.error}
              style={{ marginBottom: "0.5rem", width: "25rem" }}
            />
            <label style={{ color: "var(--primary-color)", fontSize: "12px" }}>
              Upload File
            </label>
            <div>
              {props.addEditModalStates.singleFile.value ? (
                <>
                  <div
                    style={{
                      position: "relative", 
                      display: "flex",
                      justifyContent: "center",
                      gap: "1rem",
                      alignItems: "center",
                      padding: "1rem 1rem",
                      backgroundColor: "var(--white)",
                      boxShadow: "0px 4px 15px 5px rgba(0, 0, 0, 0.15)",
                      borderRadius: "1.5rem",
                      width: "100%",
                      height: "15rem",
                      fontSize: "2rem",
                    }}
                    title={props.addEditModalStates.singleFile.value.name}
                  >
                    {props.addEditModalStates.singleFile.value.name}
                    <button
                      style={{
                        position: "absolute",
                        top: "1rem",
                        right: "3rem",
                        background: "transparent",
                        border: "none",
                        fontSize: "1.5rem",
                        cursor: "pointer",
                      }}
                      onClick={() =>
                        props.setAddEditModalStates((prevVal) => ({
                          ...prevVal,
                          singleFile: { value: null, error: "" },
                        }))
                      }
                      title="Remove File"
                    >
                      ✖
                    </button>
                  </div>
                </>
              ) : (
                <FileUpload
                  icon="upload"
                  onChange={props.handleFileChange}
                  label="Upload Resource"
                  label2="Uploaded file must be "
                  label2Span="PDF, IMG"
                  multiple={false}
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: "2rem",
                    backgroundColor: "var(--white)",
                    boxShadow: "0px 4px 15px 5px rgba(0, 0, 0, 0.15)",
                    borderRadius: "1.5rem",
                    width: "100%",
                    height: "15rem",
                  }}
                  errorMessage={props.addEditModalStates.singleFile.error}
                />
              )}
            </div>
          </InputsSection>
          <ModalButtons
            submitButtonLabel="Add"
            cancelButtonLabel="Cancel"
            onCancel={props.onCloseModal}
          />
        </ModalForm>
      )}
    </Modal>
  );
};

export default AddEditModal;
